<template>
    <div id="bot-image-message" class="" @mouseenter="hovered = true" @mouseleave="hovered = false">
        <div class="cb-img-preview" @click="openGallery">
            <img
                :src="imageSrc()"
                class="img-thumbnail ant-upload-list-picture-card-container"
                style="object-fit: cover"
            />
            <md-icon v-if="hovered" class="cb-pr-icon"> visibility</md-icon>
        </div>

        <span v-if="data.data.meta" class="message">{{ data.data.meta }}</span>
    </div>
</template>

<script>
import _ from "lodash";

export default {
    name: "BotImageMessage",
    props: ["data"],
    data() {
        return {
            previewImg: false,
            hovered: false,
        };
    },
    methods: {
        openGallery() {
            this.$emit("open-gallery", this.data);
        },
        imageSrc() {
            const imageUrl =
                _.get(this.data, "raw.payload.imageUrl", _.get(this.data, "raw.payload")) ||
                _.get(this.data, "raw.payload");
            return imageUrl;
        },
    },
};
</script>

<style lang="scss" scoped>
.cb-pr-icon {
    position: absolute;
}

.cb-img-preview {
    max-width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;

    .cb-pr-icon {
        z-index: 2;
    }
}

#bot-image-message {
    position: relative;

    .cb-img-preview:hover {
        cursor: pointer;
        filter: grayscale(100%);
    }

    .message {
        margin: 18px 6px;
        border-radius: 6px;
    }
}
</style>
